import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { colors, WMKGradient } from "../../vars/palette";
import { BlockCtaTitleTextAndButtonQuery } from "../../fragments/blockCTATitleTextAndButtonFields";
import { WmkLink } from "wmk-link";
import { buttonStyles } from "../CtaButton";

const CtaWrap = styled.div<{ height: number }>`
  ${({ height }) => (height ? `min-height: ${height}px` : "")};
  display: flex;
  justify-content: center;
`;

const CtaContainer = styled(Container)`
  background: linear-gradient(90deg, #ca2b2b 0%, #ff9200 100%);
  text-align: center;
  padding-bottom: 0.1rem;
  border-radius: 25px;
  // padding-right: calc(var(--bs-gutter-x, 0.75rem) * 0.5);
  h2 {
    color: white !important;
    margin-bottom: 1rem !important;
  }
  p {
    color: white;
  }
  position: absolute;
  padding-top: 1rem;
  padding-bottom: 1rem;
  @media screen and (max-width: 576px) {
    border-radius: 0;
  }
`;

const CtaButton = styled.div`
  & > div {
    display: flex !important;
    width: 100%;
    text-align: center;
    justify-content: center;
  }
  .cta-ttb-button {
    ${buttonStyles};
    background: white;
    color: ${colors.hex("primary")};
    width: 70%;
  }
  @media screen and (max-width: 576px) {
    .cta-ttb-button {
      width: 100%;
    }
  }
`;

export const CtaTitleTextButton = ({
  block,
}: {
  block: BlockCtaTitleTextAndButtonQuery;
}) => {
  const [height, setHeight] = useState(0);
  const refCta = useRef<HTMLDivElement>();

  useEffect(() => {
    const current = refCta.current;
    const handleResize = () => {
      const rect = current ? current.getBoundingClientRect() : null;
      if (rect) {
        setHeight(rect.height);
      }
    };
    window.addEventListener("resize", handleResize);
    const timeout = setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeout);
    };
  });

  const { title, copy, link, linkText } = block;
  return (
    <CtaWrap height={height}>
      <CtaContainer ref={refCta}>
        <Row>
          <Col>
            <h2>{title}</h2>
          </Col>
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col>
            <p>{copy}</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <CtaButton>
              <WmkLink
                className="cta-ttb-button"
                to={
                  link.__typename === "ContentfulLinksExternal"
                    ? link.url
                    : link.__typename === "ContentfulWmkBlogs"
                    ? `/blog/${link.slug}`
                    : link.__typename === "ContentfulWmkSolutions"
                    ? `/solutions/${link.slug}`
                    : `/${link.slug}`
                }
              >
                {linkText}
              </WmkLink>
            </CtaButton>
          </Col>
        </Row>
      </CtaContainer>
    </CtaWrap>
  );
};
